import { useNavigate, useParams } from "react-router";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import MainTable from "../../../components/tables/MainTable";
import endpoints from "../../../services/endpoints";
import { TableDetailsItem } from "../../../components/tables/tableFunctions";
import useTranslation from "../../../components/CustomHooks/useTranslation";
import { adminContents } from "../../AdminManagement/components/AdminManagementContent";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { showToast } from "../../../components/toastMessage/toastSlice";
import { useDispatch } from "react-redux";

export default function ListOfAchievements() {
  const navigation = useNavigate();
  const { target } = endpoints;
  const { id } = useParams();
  const { translate } = useTranslation(adminContents);
  const pathname = useSelector((state: RootState) => state.geolocation.previousUrl);
  const { entireResponse } = useSelector((state: RootState) => state.list);
  const dispatch = useDispatch();
  const TableDetails: { [key: string]: TableDetailsItem } = {
    "From Date": {
      id: "from_date",
    },
    "To Date": {
      id: "to_date",
    },
    "Target Type": {
      id: "target_type",
    },
    "Target Amount": {
      id: "target_amount",
      custom: ["target_amount"]
    },
    "On Target Achievement Service Fee Percentage": {
      id: "on_target_service_fee_percentage",
      custom: ["on_target_service_fee_percentage"],
      className: "min-w-[450px]"
    },
    "Target Achieved": {
      id: "target_achieved",
      custom: ["target_achieved"]
    },
    "On Target Achievement Amount Recieved": {
      id: "achievement_amount_received",
      custom: ["achievement_amount_received"],
      className: "min-w-[400px]"
    },
    "Service Fee Recieved Date": {
      id: "service_fee_received_date",
      className: "min-w-[250px]"
    },
    Actions: {
      id: "actions",
      className: "min-w-[200px]",
      actionTypes: ["edit", "entry"],
    },
  };
  const handleActions = async (dataId: string, key: string, text?: string) => {
    if (key === "edit") {
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement/add-on-target/${dataId}`);
    } else if (key === "entry") {
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement/add-on-target-achievement/${dataId}`);
    }
  }
  const addButtonClick = () => {
    if (entireResponse?.etopup_enabled || entireResponse?.bundle_activation_enabled) {
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement/add-on-target`);
    } else {
      dispatch(showToast(
        {
          message: "Targets for eTop up and bundle activation already exists in Running / Not Started state, so new targets cannot be added at the moment.",
          type: "error",
        }
      ));
    }

  };
  const staticText = {
    emptyScreenText: {
      heading1: translate("There are no On Target Achievement's added yet"),
      heading2: translate("Click “Add On Target” to create one"),
    },
  };
  return (
    <div>
      <Breadcrumbs
        navPath={["MNO Management", "List of MNO’s", "View Details", "View On Target Achievement"]}
        heading="View On Target Achievement"
        noNavigation
        links={[pathname ? pathname : "/mno-management/list-of-mnos", pathname ? pathname : "/mno-management/list-of-mnos", `/mno-management/list-of-mnos/view-mno/${id}`, `/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement`]}
        button={{
          buttonName: "Add On Target",
          className: "w-[179px] h-[45px]",
          buttonOnclick: addButtonClick, // Corrected function type
        }}
      // list={true}
      />
      <MainTable
        staticText={staticText}
        mainEndPoint={`${target}${id}`}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1" }}
        searchPlaceholder={"Search by MNO name"}
        filters={false}
        exporting={false}
        search={false}
        notfoundRoute={{ state: { route: '/mno-management/list-of-mnos' } }}
      />
    </div>
  );
}
